import React, { useContext } from 'react';
import Plans from './Plans/Plans';
import PlanComparison from './PlanComparison/PlanComparison';
import { AppSettingsContext } from '../context/AppSettings.context';
import Description from './Description/Description';
import { AppContext } from '../context/AppContext';
import { IOneTimePaymentItem, IPlan } from '../model';

interface IProps {
  plans: IPlan[];
  onePaymentItems: IOneTimePaymentItem[];
  sport: string;
}

const MainContent = (
  {
    plans,
    onePaymentItems,
    sport
  }: IProps
) => {
  const { comparison } = useContext(AppSettingsContext)
  const contextData = useContext(AppContext)
  const { isShowAll, showAll } = contextData || {};

  return <>
    <Plans plans={plans} onePaymentItems={onePaymentItems} showAll={showAll} isShowAll={isShowAll || false}/>
    <Description/>
    {sport !== 'Specials' && comparison ? <PlanComparison plans={plans} isShowAll={isShowAll} sport={sport}/> : ''}
  </>
};

export default MainContent;
